import { render, staticRenderFns } from "./monthlyProductStatisticsDetail.vue?vue&type=template&id=e25d2d38&scoped=true"
import script from "./monthlyProductStatisticsDetail.vue?vue&type=script&lang=js"
export * from "./monthlyProductStatisticsDetail.vue?vue&type=script&lang=js"
import style0 from "./monthlyProductStatisticsDetail.vue?vue&type=style&index=0&id=e25d2d38&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e25d2d38",
  null
  
)

export default component.exports